<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-05 09:24:51
 * @LastEditors: hexy
 * @LastEditTime: 2024-04-10 13:55:49
 * @Description: 配合比库-复用配合比
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\components\mixRawAgain.vue
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="lookRawDialog" width="960px" :close-on-click-modal="false" :append-to-body="true" :before-close="resetRawFromDate">
      <span slot="title" class="dialog-title">{{ lookRawTitle }}</span>
      <div class="dialoginfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          <span v-if="isShow">产品名称:{{ productName }}</span>
          <span v-if="isShow">站点:{{ stationName }}</span>
          
          <!-- <el-input v-model="tableParam.productName" size="mini" style="width: 130px" placeholder="请输入"></el-input> -->
          
          <!-- <el-select ref="selection" v-model="tableParam.stationId" filterable>
            <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          配合比名称:
          <el-input v-model="tableParam.name" size="mini" style="width: 130px" placeholder="请输入"></el-input>
          <!-- <el-input v-model="tableParam.stationName" size="mini" style="width: 130px"></el-input> -->
          <div style="position: absolute; right: 0; top: 0">
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="queryMix()">搜索</el-button>
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="init()">重置</el-button>
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="tableData"
          tooltip-effect="dark"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
          <!-- <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>> -->
          <el-table-column label="产品名称" align="center" prop="productName" :min-width="160"></el-table-column>
          <el-table-column label="配合比名称" align="center" prop="name" :min-width="140"></el-table-column>
          <el-table-column label="站点" align="center" prop="stationName" :min-width="100"></el-table-column>
          <el-table-column label="搅拌时间" align="center" prop="mixTime" :min-width="100"></el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" layout="total, prev, pager, next, jumper" :total="total" @current-change="queryMix()"></el-pagination>
      </div>
      <div style="margin-top: 10px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableDataDetail" tooltip-effect="dark">
          <el-table-column label="原物料名称" align="center" prop="name" :min-width="160"></el-table-column>
          <el-table-column label="理论用量(kg/m³)" align="center" prop="theoreValue" :min-width="100"></el-table-column>
          <el-table-column label="偏差(kg)" align="center" prop="deviation" :min-width="100"></el-table-column>
          <el-table-column v-if="isMixOut" label="对外量(kg/m³)" align="center" prop="theoreValueTrueOut" :min-width="100"></el-table-column>
          <el-table-column v-if="isMixOut" label="对外仓" align="center" prop="rawFormCodeOut" :min-width="100">
          <template slot-scope="scope">
            {{warehouseBindList.find(item => item.useCode == scope.row.rawFormCodeOut)?.useAliasName}}
          </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetRawFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveRawFromDate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryMix } from "@/api/basicConfig/mixForm.js";
import { getUserAutList } from "@/api/common.js";
export default {
  data() {
    return {
      /*表格增删改查及下载接口*/
      options: [],
      stationList: [],
      isShow:false,
      /*表格数据*/
      lookRawTitle: "复用配合比",
      tableParam: {
        page: 1,
        pageSize: 10,
        name: "",
        stationId: "",
        productName: "",
      },
      total: 0,
      tableData: [],
      tableDataDetail: [],
      selectRaw: [],
      mixName: "",
      mixTime: "",
      mixId: "",
      productName: "",
      stationName: "",
      stationId: "",
    };
  },
  props: {
    lookRawDialog: {
      type: Boolean,
      default: false,
    },
    isShowType: {
      type: Boolean,
      default: false,
    },
    isMixOut: {
      type: Boolean,
      default: false,
    },
    proName: {
      type: String,
      default: "",
    },
    statName: {
      type: String,
      default: "",
    },
    statId: {
      type: String,
      default: "",
    },
    warehouseBindList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    proName(val) {
      this.productName = val;
      this.tableParam.productName = val;
    },
    statName(val) {
      this.stationName = val;
    },
    statId(val) {
      this.tableParam.stationId = val;
      this.stationId = val;
    },
    isShowType(val) {
      this.isShow = val;
    },
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, name: "",enable:1, stationId: this.stationId, productName: this.productName };
    this.stationList = await getUserAutList(true);
    this.queryMix();
  },
  methods: {
    //选择
    handleCurrentChange(val) {
      if (val) {
        console.log(val)
        this.mixName = val.name;
        this.mixTime = val.mixTime;
        this.mixId = val.id
        if (val.mixInfo != "" || val.mixInfo != null) {
          this.tableDataDetail = JSON.parse(val.mixInfo);
        } else {
          this.tableDataDetail = [];
        }
      }
    },
    init() {
      this.tableParam = {  page: 1,
        pageSize: 10,
        name: "",
        enable:1,
        stationId: this.stationId,
        productName: this.productName, };
        this.tableDataDetail = []
      this.queryMix();
    },
    queryMix() {
      this.tableParam.stationId = this.stationId
      queryMix({ ...this.tableParam }).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });
    },
    //主页面添加事件
    async addClick(stationId) {
      this.stationId = stationId
      console.log(stationId)
      await this.init();
    },
    resetRawFromDate() {
      this.$emit("update:lookRawDialog", false);
      this.$refs.multipleTable.clearSelection();
    },
    /*保存/修改弹窗*/
    saveRawFromDate() {
      console.log(this.tableDataDetail)
      this.$emit("selectRawDetail", this.tableDataDetail, this.mixName, this.mixTime,this.mixId);
      this.resetRawFromDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
